module.exports = __webpack_public_path__ + "img/Helmut-Oyarzun.31d495b5.jpg";